module.exports = __webpack_public_path__ + "fonts/SeoulNamsanM.e81305c5.otf";